import { useQuery } from "@apollo/client";

import { GqlProjectExportGetAllParams, gql } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

export const PROJECT_EXPORT_GET_ALL = gql(`
    query ProjectExportGetAll($clientId: ID!, $params: GqlProjectExportGetAllParams) {
        projectExportGetAll(clientId: $clientId, params: $params) {
            data {
                id
                createdAt
                projectIds
                mediaIncluded
                projects {
                    id
                    name
                }
                researchTypes {
                    id
                    name
                }
                template
                dataJobId
                dataMediaItem {
                    id
                    url
                }
                mediaJobId
                mediaMediaItem {
                    id
                    url
                }
            }
            queryInfo {
                sortableColumns
                    filterOptions {
                    ... on GqlFilterOptionText {
                        filterType
                        label
                        key
                    }
                    ... on GqlFilterOptionSelect {
                        filterType
                        label
                        key
                        options {
                            label
                            value
                        }
                    }
                    ... on GqlFilterOptionMultiSelect {
                        filterType
                        label
                        key
                        dataModel
                    }
                    ... on GqlFilterOptionBoolean {
                        filterType
                        label
                        key
                    }
                }
                paginationOption {
                    page
                    total
                }
            }
        }
    }
`);

export function useProjectExports(clientId: string, params: GqlProjectExportGetAllParams) {
    const { data, loading, error, refetch } = useQuery(PROJECT_EXPORT_GET_ALL, {
        variables: { clientId, params: params },
        errorPolicy: "all",
    });

    const queryInfo = data?.projectExportGetAll?.queryInfo;
    const [filterOptions, total] = useCacheFilterOptions(queryInfo?.filterOptions, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        refetch,
        totalRows: total,
        sortableColumns: queryInfo?.sortableColumns,
        filterOptions: filterOptions,
        data: data?.projectExportGetAll?.data,
    };
}
